import TotalPrice from 'components/Price/TotalPrice/container';

export default TotalPrice;
